"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FileInput = void 0;
exports.handleChangeFileInput = handleChangeFileInput;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function handleChangeFileInput(e, onFileSelected) {
  var selectedFile = e.target.files[0];
  var formData = new window.FormData();
  formData.append('file', selectedFile, selectedFile.name);
  onFileSelected(formData, selectedFile, e);
}
var FileInput = function FileInput(_ref) {
  var text = _ref.text,
    onChange = _ref.onChange,
    onFileSelected = _ref.onFileSelected,
    accept = _ref.accept,
    id = _ref.id,
    className = _ref.className,
    style = _ref.style;
  var uniqueId = Math.random().toString().replace('0.', 'fileUpload_');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id || uniqueId,
    className: className || "ui button primary",
    style: style
  }, text), /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    id: id || uniqueId,
    accept: accept || ".csv",
    onChange: onChange ? function (e) {
      return onChange(e);
    } : function (e) {
      return handleChangeFileInput(e, onFileSelected);
    }
  }));
};
exports.FileInput = FileInput;
FileInput.propTypes = {
  text: _propTypes["default"].string.isRequired,
  onFileSelected: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  accept: _propTypes["default"].string,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  id: _propTypes["default"].string
};
var _default = FileInput;
exports["default"] = _default;